module.exports = __webpack_public_path__ + "img/33d7b71.png";